import React, { useCallback, useState } from 'react';

import { Box, Button } from '@mui/material';
import { ViewDetailIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { PREVIEW_ACTION_LABEL } from '../../FormChangeHistory.constants';
import { PreviewPanesPropType } from '../../FormChangeHistory.propTypes';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import { getPreviewModalTitle } from '../../FormChangeHistory.utils';
import TemplatePreviewModal from '../TemplatePreviewModal';

import { previewActionStyles } from './TemplatePreviewAction.styles';

/** Opens a template's sides side by side: a change's, or a version's against now. */
const TemplatePreviewAction = ({
  auditId,
  kind,
  templateKind,
  panes,
  parts = null,
  occurredAtUtc = null,
  isHidden = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);

  if (isHidden) {
    return null;
  }

  return (
    <Box sx={previewActionStyles}>
      <Button
        data-kind={kind}
        data-template-kind={templateKind}
        data-testid={FormChangeHistoryTestIds.PREVIEW_BUTTON}
        startIcon={<ViewDetailIcon size={IconSize[16]} />}
        variant="line"
        onClick={onOpen}
      >
        {PREVIEW_ACTION_LABEL[kind]}
      </Button>
      <TemplatePreviewModal
        auditId={auditId}
        isOpen={isOpen}
        panes={panes}
        parts={parts}
        templateKind={templateKind}
        title={getPreviewModalTitle(kind, occurredAtUtc)}
        onClose={onClose}
      />
    </Box>
  );
};

TemplatePreviewAction.propTypes = {
  auditId: PropTypes.string.isRequired,
  kind: PropTypes.string.isRequired,
  templateKind: PropTypes.string.isRequired,
  panes: PreviewPanesPropType.isRequired,
  parts: PropTypes.arrayOf(PropTypes.object),
  occurredAtUtc: PropTypes.string,
  isHidden: PropTypes.bool,
};

export default TemplatePreviewAction;
